import React, { useEffect } from "react";
import {
	DatePickerInputNew,
	InputDevicesGroup,
	InputGroups,
	InputParentGroup,
} from "../../Helpers/Input/Input";
import { useSelector } from "react-redux";
import trans from "../../../utils";

export default function EventsInput({
	setStartDate,
	setEndDate,
	selectedUser,
	selectedId,
	setSelectedUser,
	setSelectedVehicles,
}) {
	const inf = useSelector((state) => state.users.user);

	useEffect(() => {
		return setSelectedUser(inf?.id);
	}, [setSelectedUser, inf]);

	const handleDateRangeChange = ({ startDate, endDate }) => {
		setStartDate(startDate ? startDate.toISOString() : null);
		setEndDate(endDate ? endDate.toISOString() : null);
	};

	const handleUserChange = (value) => {
		setSelectedUser(value);
	};
	const handleVehicleIdChange = (value) => {
		setSelectedVehicles(value);
	};

	return (
		<div className="">
			<InputGroups
				id="parent"
				name="parent"
				title={trans("Groups")}
				formstyle="form-input"
				onChange={handleUserChange}
			/>
			<InputDevicesGroup
				title={trans("Vehicle")}
				formstyle="form-input"
				placeholder={trans("Select Vehicle")}
				value={selectedId || ""}
				userID={selectedUser}
				onChange={handleVehicleIdChange}
			/>
			<DatePickerInputNew
				id="dateRange"
				name="dateRange"
				title={trans("Date Range")}
				formstyle="form-input"
				onChange={handleDateRangeChange}
			/>
		</div>
	);
}
